import { BUILDINGS_QUERY_KEY } from '@domain/buildings';
import { UseMutation, useMutationWrapper } from '@hooks/useMutationWrapper';
import { closeBuilding } from '@services/buildings/buildingsService';
import { useQueryClient } from 'react-query';

const useCloseBuilding = (
  venueId: string
): UseMutation<void, Error, string, unknown> => {
  const queryClient = useQueryClient();

  return useMutationWrapper<void, Error, string>(
    (buildingId) => closeBuilding(buildingId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(BUILDINGS_QUERY_KEY(venueId));
      }
    }
  );
};

export { useCloseBuilding };
